module.exports = __webpack_public_path__ + "img/airdrop.bf1e9e00.png";